import { useEffect } from 'react'
import { useOutletContext } from 'react-router-dom'

import { PerformanceReviewOverviewReporteesCountDocument } from 'generated/resources/graphql'
import { compact } from 'lodash'

import Filter from 'modules/core/components/Filter'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import {
  isManagerFilterVisible,
  useFilter,
} from 'modules/performance_process/components/review/show/Filters/context'
import { ReviewOverviewOutletContext } from 'modules/performance_process/pages/reviews/show/overview'

export const OnlyDirectReportsFilter = () => {
  const { reviewProcess } = useOutletContext<ReviewOverviewOutletContext>()
  const { value, setValue } = useFilter('onlyDirectReports')
  const { value: managerValue } = useFilter('managerId')

  const { data } = useQuery(PerformanceReviewOverviewReporteesCountDocument, {
    variables: { managerId: Number(managerValue) },
    fetchPolicy: 'cache-first',
    skip: !managerValue,
  })

  const directReportsCount = data?.employees?.directReportees?.totalCount ?? 0
  const reportsCount = data?.employees?.reportees?.totalCount ?? 0
  const hasDirectReports = directReportsCount > 0
  const hasReports = reportsCount > directReportsCount

  useEffect(() => {
    if (!hasDirectReports && hasReports) {
      setValue(false)
    }
  }, [hasDirectReports, hasReports, setValue])

  if (!isManagerFilterVisible(reviewProcess) || !managerValue) {
    return null
  }
  if (!hasDirectReports && !hasReports) {
    return null
  }

  return (
    <Filter.SingleChoice
      label={i18n.t(
        'performance_process.reviews.target_datatable.filters.only_direct_reports.title'
      )}
      value={value}
      options={compact([
        hasDirectReports && {
          label: i18n.t(
            'performance_process.reviews.target_datatable.filters.only_direct_reports.options.yes'
          ),
          value: true,
        },
        hasReports && {
          label: i18n.t(
            'performance_process.reviews.target_datatable.filters.only_direct_reports.options.no'
          ),
          value: false,
        },
      ])}
      onValueChange={setValue}
      noFooter
    />
  )
}
